import React from 'react';
import SectionHead from 'ui-components/SectionHead';
import BadFitTable from './components/bad-fit-table/BadFitTable';

import './bad-fit.scss'

const BadFit = () => {
    return (
        <div className='bad-fit'>
            <SectionHead head={"Bad Fit"}/>
            <BadFitTable/>
        </div>
    );
};

export default BadFit;